import {
  refreshOnceOnDynamicImportError,
  ErrorComponent,
} from "@src/global_functions/errorBoundaryUtils";
import * as React from "react";
import { bugsnagClient } from "../bugsnag";

class ErrorBoundary extends React.Component<
  {
    label: string;
    children: any;
  },
  any
> {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: any) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(
    e: Error,
    errorInfo: {
      componentStack: string;
    }
  ): void {
    const metaData = {
      type: `Error Boundary triggered for ${this.props.label}`,
      label: this.props.label,
      message: e.message,
      stack: JSON.stringify(e.stack),
      componentStack: errorInfo.componentStack,
    } as const;
    bugsnagClient?.leaveBreadcrumb(
      `Error Boundary triggered for ${this.props.label}`,
      metaData
    );
    bugsnagClient?.notify(e, (ev) => {
      ev.severity = "error";
      ev.addMetadata("ErrorBoundary", {
        label: this.props.label,
      });
    });

    refreshOnceOnDynamicImportError(e);
  }

  render() {
    if (this.state.hasError) {
      return <ErrorComponent />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
